import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { saveBoost } from '../modules/actions';
import Boost from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.boost || {},
    app: state.app,
    saveBoostStatus: state.boost.saveBoostStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    saveBoost: bindActionCreators(saveBoost, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Boost));



// WEBPACK FOOTER //
// ./src/components/Boost/container/index.js